import { render } from "./ReceiptDetail.vue?vue&type=template&id=f00bbb98"
import script from "./ReceiptDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptDetail.vue?vue&type=script&lang=js"

import "./ReceiptDetail.vue?vue&type=style&index=0&id=f00bbb98&lang=css"

import exportComponent from "E:\\workBase\\Vue\\hans-amdin-mobiles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__